import { T } from '@transifex/react'
import React, { FunctionComponent } from 'react'
import {
  DECIMAL_PLACES,
  useFormatPercentage,
} from '../../helpers/formatNumberHooks'
import { PaymentInfoBanner } from './PaymentInfoBanner'

type Props = {
  /** LSPay cash discount rate, as a percentage (e.g. `4` for 4%). */
  rate: number
}

/**
 * Banner shown above the payment input when the active outlet has an LSPay
 * cash discount configured. Mirrors the look & feel of `CashDiscountingBanner`.
 */
export const LspCashDiscountingBanner: FunctionComponent<Props> = ({
  rate,
}) => {
  const formatPercentage = useFormatPercentage({
    minimumFractionDigits: DECIMAL_PLACES,
  })

  return (
    <PaymentInfoBanner
      message={
        <T
          _str="Cash discount {rate} will apply if paid in cash."
          _context="LSPay cash discounting banner"
          rate={formatPercentage(rate / 100)}
        />
      }
    />
  )
}
